import React, { useRef, useEffect } from "react";
import { Microphone } from "@/types";
import Link from "next/link";
import { CldImage } from "next-cloudinary";
import { formatEnumValue, formatEnumValueCompact } from "@/lib/formatters";
// import { MicrophoneData } from "@/lib/hygraph";
// import { AdvancedImage } from "@cloudinary/react";

// import { color } from "@cloudinary/url-gen/qualifiers/background";
import classNames from "classnames";
import { PiWaveformBold } from "react-icons/pi";
// import { CloudinaryImage } from "@/lib/hygraph";

const MicrophoneCard = ({
  microphone,
  listOrCard,
  id,
  onRegister,
  firstLetter,
}: {
  microphone: Microphone;
  listOrCard: string;
  id?: string;
  onRegister?: (id: string, letter: string, element: HTMLElement) => void;
  firstLetter?: string;
}) => {
  const myImage = microphone.exteriorImages[0];
  const cardRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (cardRef.current && onRegister && id && firstLetter) {
      onRegister(id, firstLetter, cardRef.current);
    }
  }, [id, firstLetter, onRegister]);
  // myImage.format("auto");

  // Resize to 250 x 250 pixels using the 'fill' crop mode.
  //   myImage
  //     .namedTransformation("t_remove-bkgr-sharpen")
  //     .resize(limitPad().width(160).height(160));

  const list = listOrCard === "list" ? true : false;

  const hasAudio =
    !!microphone.microphoneAudioRecordings &&
    microphone.microphoneAudioRecordings.length > 0;
  const hasIr =
    !!microphone.microphoneIrRecordings &&
    microphone.microphoneIrRecordings.length > 0;

  const linkStyles = classNames({
    "group flex items-center bg-black/40 hover:bg-purple-900 hover:duration-200 cursor-pointer transition ease-in-out hover:text-opacity-100":
      true,
    // if the viewing is set to list view
    "rounded-2xl overflow-hidden ring-4 ring-purple-900/0 hover:ring-purple-900/50 ":
      !list,
    // if the viewing is set to card view
    "justify-between ": list,
  });

  const innerStyles = classNames({
    "w-full": true,
    "p-5 space-y-2": !list,
    "border-b border-white/10 px-5 py-2 flex space-x-5 items-center justify-between hover:py-4 duration-200 transition-all ease-in-out":
      list,
  });

  return (
    <li className="mic-item" ref={cardRef} id={id}>
      <Link
        className={linkStyles}
        href={`/collection/${encodeURIComponent(microphone.slug)}`}
      >
        {!list && myImage.public_id && (
          <CldImage
            src={myImage.public_id}
            width="160"
            height="160"
            crop="lpad"
            quality="auto:best"
            format="auto"
            alt="a Vintage Microphone"
            namedTransformations={["mic-thumb"]}
            className="w-[120px] h-[120px] md:w-[160px] md:h-[160px]"
          />
        )}
        <div className={innerStyles}>
          <h2 className="text-white text-sm md:text-base font-body font-medium leading-snug mb-1">
            {microphone.manufacturer} {microphone.model}
          </h2>
          <div className={classNames({ "flex flex-col items-end": list })}>
            <div
              className={classNames(
                "flex text-white/40 group-hover:text-white/100 text-[11px] md:text-xs gap-2 flex-wrap pt-5",
                { "justify-end": list },
              )}
            >
              {microphone.productionStartYear && (
                <h3 className="leading-tight font-body tracking-wider">
                  {microphone.productionStartYear}
                </h3>
              )}
              {microphone.microphoneType && (
                <h3 className="leading-tight font-body tracking-wider">
                  {formatEnumValueCompact(microphone.microphoneType)}
                </h3>
              )}
              {microphone.polarPattern && (
                <h3 className="leading-tight font-body tracking-wider">
                  {microphone.stereo
                    ? `Stereo ${formatEnumValue(microphone.polarPattern)}`
                    : formatEnumValue(microphone.polarPattern)}
                </h3>
              )}
            </div>
            {(hasAudio || hasIr) && (
              <div className="flex text-white/40 group-hover:text-white/100 text-[11px] md:text-xs gap-3 items-center pt-2">
                {hasAudio && (
                  <span
                    className="flex items-center gap-1"
                    title="Audio recording available"
                  >
                    <PiWaveformBold className="w-3.5 h-3.5" />
                  </span>
                )}
                {hasIr && (
                  <span
                    className="flex items-center gap-1 font-body tracking-wider"
                    title="Impulse response file available"
                  >
                    IR
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </Link>
    </li>
  );
};

export default MicrophoneCard;
